<template>
    <div class="overflow-visible">

        <div    v-if="!currentNotificationSettings.loading">
            <!-- Notifications Enabled -->
            <h5 class="text-left">Notifications</h5>
            <div class="mt-1 sm:mt-0 sm:col-span-2 flex items-center">
                <span class="relative z-0 inline-flex shadow-sm rounded-md">
                    <button     type="button"
                                @click="toggleNotificationsEnabled"
                                :class="currentNotificationSettings.enabled ? 'bg-blue-200' : 'bg-white'"
                                class="relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                        Enabled
                    </button>
                    <button     type="button"
                                @click="toggleNotificationsEnabled"
                                :class="!currentNotificationSettings.enabled ? 'bg-blue-200' : 'bg-white'"
                                class="-ml-px relative inline-flex items-center px-4 py-2 rounded-r-md border border-gray-300 text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                        Disabled
                    </button>
                </span>
              <banner-error
                :class="!hasAnyMethodsEnabled && currentNotificationSettings.enabled ? 'visible' : 'invisible'"
                class="ml-2"
              >
                <template #title>
                  No Notification Methods Enabled
                </template>
                <template #content>
                  You'll need to add at least one notification method for notifications to be enabled.
                </template>
              </banner-error>
            </div>



            <div    v-if="currentNotificationSettings.enabled">
                <div class="hidden sm:block">
                    <div class="py-5">
                        <div class="border-t border-gray-200"></div>
                    </div>
                </div>

                <!-- Notification Methods -->
                <div    class="my-4">
                    <h5 class="text-left pb-4">Methods to Send Notifications</h5>

                    <!-- Email -->
                    <div    v-if="hasEmailFeature"
                            class="grid grid-cols-4 my-2">
                        <div    class="flex flex-col col-span-4 lg:col-span-1 items-start lg:justify-start justify-center lg:items-center">
                            <span>Email</span>
                            <div    class="flex justify-center items-start">
                                <span   :class="iconEmail"></span>
                                <div    class="flex items-center ml-2">
                                    <span   @click="createNotification('email')"
                                            class="cursor-pointer lnr icon-plus-circle text-green-500 mr-2"></span>
                                </div>
                            </div>
                        </div>
                        <div    class="pt-2 lg:pt-0 pl-4 col-span-4 lg:col-span-3 grid grid-cols-1">
                            <div    v-for="(notification, index) in currentNotificationSettings.methods.email"
                                    class="w-full flex justify-center items-center"
                            >
                                <floating-input     v-model:value="currentNotificationSettings.methods['email'][index]"
                                                    label="Email"
                                                    class="w-full lg:w-2/3"
                                                    :id="`email_input_${index}`"
                                ></floating-input>
                                <span   @click="deleteNotification('email', index)"
                                        class="cursor-pointer ml-2 pb-2 lnr icon-trash"></span>
                            </div>
                        </div>
                    </div>

                    <div    v-if="hasSmsFeature"
                            class="hidden sm:block">
                        <div class="py-5">
                            <div class="border-t border-gray-200"></div>
                        </div>
                    </div>

                    <!-- SMS -->
                    <div    v-if="hasSmsFeature"
                            class="grid grid-cols-4 my-2">
                        <div    class="flex flex-col col-span-4 lg:col-span-1 items-start lg:justify-start justify-center lg:items-center">
                            <span>Text</span>
                            <div    class="flex justify-center items-start">
                                <span   :class="iconSMS"></span>
                                <div    class="flex items-center ml-2">
                                <span   @click="createNotification('text')"
                                        class="cursor-pointer lnr icon-plus-circle text-green-500 mr-2"></span>
                                </div>
                            </div>
                        </div>

                        <div    class="pt-2 lg:pt-0 pl-4 col-span-4 lg:col-span-3 grid grid-cols-1">
                            <div    v-for="(notification, index) in currentNotificationSettings.methods.text"
                                    :key="index"

                                    class="flex justify-center items-center"
                            >
                                <floating-input     v-model:value="currentNotificationSettings.methods.text[index]"
                                                    label="Phone Number (XXXXXXXXXX)"
                                                    class="w-full lg:w-2/3"
                                                    :id="`text_input_${index}`"
                                ></floating-input>
                                <span   @click="deleteNotification('text', index)"
                                        class="cursor-pointer ml-2 pb-2 lnr icon-trash"></span>
                            </div>
                        </div>
                    </div>

                    <div    v-if="hasVoiceFeature"
                            class="hidden sm:block">
                        <div class="py-5">
                            <div class="border-t border-gray-200"></div>
                        </div>
                    </div>

                    <!-- Phone Call  -->
                    <div    v-if="hasVoiceFeature"
                            class="grid grid-cols-4 my-2">
                        <div    class="flex flex-col col-span-4 lg:col-span-1 items-start lg:justify-start justify-center lg:items-center">
                            <span>Phone Call</span>
                            <div    class="flex justify-center items-start">
                                <span   :class="iconVoiceMail"></span>
                                <div    class="flex items-center ml-2">
                                    <span   @click="createNotification('voice')"
                                            class="cursor-pointer lnr icon-plus-circle text-green-500 mr-2"></span>
                                </div>
                            </div>
                        </div>
                        <div    class="pt-2 lg:pt-0 pl-4 col-span-4 lg:col-span-3 grid grid-cols-1">
                            <div    v-for="(notification, index) in currentNotificationSettings.methods.voice"
                                    class="flex justify-center items-center"
                            >
                                <floating-input     v-model:value="currentNotificationSettings.methods.voice[index]"
                                                    label="Phone Number (XXXXXXXXXX)"
                                                    class="w-full lg:w-2/3"
                                                    :id="`voice_input_${index}`"
                                ></floating-input>
                                <span   @click="deleteNotification('voice', index)"
                                        class="cursor-pointer ml-2 pb-2 lnr icon-trash"></span>
                            </div>
                        </div>
                    </div>

                    <div class="hidden sm:block">
                        <div class="py-5">
                            <div class="border-t border-gray-200"></div>
                        </div>
                    </div>

                    <!-- Push Notifications  -->
                    <div class="grid grid-cols-4 my-2">
                        <div    class="flex flex-col col-span-4 lg:col-span-1 items-start lg:justify-start justify-center lg:items-center">
                            <span>Push Notifications</span>
                            <div    class="flex justify-center items-start">
                                <span   :class="iconPushNotification"></span>
                                <div    class="flex items-center ml-2">
                                    <span   class="cursor-pointer lnr icon-plus-circle text-green-500 mr-2 invisible"></span>
                                </div>
                            </div>
                        </div>
                        <div    class="pt-2 lg:pt-0 pl-4 col-span-4 lg:col-span-3 grid grid-cols-1">
                            <div class="flex justify-center items-center">
                                <loading v-if="loadingPushNotificationModels" width="w-full lg:w-2/3">

                                </loading>
                                <div v-else class="w-full lg:w-3/4">
                                    <select2
                                        :multiple="true"
                                        :options="pushNotificationArray"
                                        :value="currentNotificationSettings.methods['push']"
                                        name="pushMethodSelect"
                                        @input="this.updatePushNotifications"
                                    >
                                    </select2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="hidden sm:block">
                    <div class="py-5">
                        <div class="border-t border-gray-200"></div>
                    </div>
                </div>

                <user-notification-times-edit   v-if="currentNotificationSettings.timesLoaded"
                                                v-model:times="currentNotificationSettings.times"
                                                v-model:server-times="currentNotificationSettings.serverTimes"
                                                v-model:time-choice="currentNotificationSettings.timeChoice"
                ></user-notification-times-edit>

              <div class="hidden sm:block">
                <div class="py-5">
                  <div class="border-t border-gray-200"></div>
                </div>
              </div>

              <h5 class="text-left">Alarm Escalation and Repeating</h5>
              <p class="text-sm leading-5 text-gray-600">
                Alarm Notification Delay is the time between when an alarm is generated and when the first notification is sent.
              </p>
              <p class="text-sm leading-5 text-gray-600">
                Re-notification Interval is the time between notifications when an alarm is active (not snoozed or resolved).
              </p>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-x-2">
                <floating-input     v-model:value="currentNotificationSettings.delayTime"
                                    id="delay_time"
                                    label="Alarm Notification Delay (Minutes)"
                ></floating-input>
                <floating-input     v-model:value="currentNotificationSettings.renotificationTime"
                                    id="renotification_time"
                                    label="Re-notification Interval (Minutes)"
                ></floating-input>
              </div>
              <div  v-if="unSnoozeNotificationEnabled">
                  <h5>Un-snooze Notifications</h5>
                  <p  class="text-sm leading-5 text-gray-600">
                      These Notifications will be sent when an alarm you are setup to receive notifications for is unsnoozed.
                  </p>
                  <unsnooze-notification-radio
                      v-model:unsnooze-notification-setting="currentNotificationSettings.unsnoozeNotificationType"
                  ></unsnooze-notification-radio>
              </div>
            </div>

        </div>
        <div    v-else>
            Loading Notifications for User ... Please wait.
        </div>
    </div>
</template>

<script>

import {iconNamesMixin} from '@/mixins/IconNamesMixin';

import Toggle from "@/components/elements/toggle";
import FloatingInput from "@/components/elements/FloatingInput";
import UserNotificationTimesEdit from "@/components/Users/UserNotificationTimesEdit";
import axios from "axios";
import Select2 from "@/components/elements/select2";
import Loading from "@/components/elements/loading";
import {Features} from "@/mixins/AuthorizationHelpers/Features";
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import BannerError from "../Banners/BannerError.vue";
import UnsnoozeNotificationRadio from "./UnsnoozeNotificationRadio.vue";

export default {
    name: "UserSetupNotifications",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {
        UnsnoozeNotificationRadio,
        BannerError, Loading, Select2, UserNotificationTimesEdit, FloatingInput, Toggle},
    emits: ['update:currentNotificationSettings'],
    compatConfig: { COMPONENT_V_MODEL: false },
    props: {
        userId: Number,
        currentNotificationSettings: Object,
        companyId: String,
        unSnoozeNotificationEnabled: Boolean,
    },
    data() {
        return {
            pushNotifications: {},
            loadingPushNotificationModels: true,
        }
    },
    created() {
        this.getMobilePushInfo();
    },
    mounted() {
    },
    methods: {
        createNotification(type) {
            let notifs = this.currentNotificationSettings
            notifs.methods[type].push('')
            this.updateNotifications(notifs)
        },
        deleteNotification(type, index) {
            let notifs = this.currentNotificationSettings
            notifs.methods[type].splice(index, 1)
            this.updateNotifications(notifs)
        },
        updateNotifications(notifs) {
            this.$emit('update:currentNotificationSettings', notifs)
            this.$forceUpdate()
        },
        toggleNotificationsEnabled() {
            let notifs = this.currentNotificationSettings
            notifs.enabled = !notifs.enabled
            this.updateNotifications(notifs)
        },
        getMobilePushInfo() {
            axios.get(this.company.buildCompanyApiInternalRoute(`users/${this.userId}/mobile-push-info`)).then(response => {
                this.pushNotifications = response.data.data;
                this.loadingPushNotificationModels = false;
            }).catch(error => {

            }).then(() => {

            })
        },
        updatePushNotifications() {
            let newPushMethods = [];
            let elementName = "pushMethodSelect"
            let val = $('[name=' + elementName + ']').val()
            val.forEach((item, key) => {
                newPushMethods.push(parseInt(item))
            })
            this.currentNotificationSettings.methods['push'] = newPushMethods;
            this.updateNotifications(this.currentNotificationSettings);
        },

    },
    computed: {
        pushNotificationArray(){
            let result = {};
            _.map(this.pushNotifications, (val, key, coll) => {
                result[val['id']] = val['device_name_pretty'];
            })
            return result;
        },
        hasEmailFeature() {
            return this.featureLevel.hasFeature(Features.NOTIFICATION_METHODS_EMAIL, this.companyId)
        },
        hasSmsFeature() {
            return this.featureLevel.hasFeature(Features.NOTIFICATION_METHODS_SMS, this.companyId)
        },
        hasVoiceFeature() {
            return this.featureLevel.hasFeature(Features.NOTIFICATION_METHODS_VOICE, this.companyId)
        },
        hasPushFeature() {
            return this.featureLevel.hasFeature(Features.NOTIFICATION_METHODS_PUSH, this.companyId)
        },
        hasAnyMethodsEnabled(){
          // Check to see if any this.currentNotificationSettings[key][] has length > 0 and items with length > 1
          let methods = this.currentNotificationSettings.methods
          let hasAny = false
          for (let key in methods) {
            if (methods[key].length > 0) {
              for (let i = 0; i < methods[key].length; i++) {
                if (methods[key][i].length > 0) {
                  hasAny = true
                  break
                }
              }
            }
          }
          return hasAny
        }
    },
    watch: {
        notificationsEnabled() {
            let notifs = this.currentNotificationSettings
            notifs['enabled'] = this.notificationsEnabled
            this.updateNotifications(notifs)
        },
    },
}
</script>

<style scoped>

</style>